/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Aai20Document } from '../../asyncapi/v2/models/Aai20Document';
import { Aai20SecurityScheme } from '../../asyncapi/v2/models/Aai20SecurityScheme';
import { Document } from '../../core/models/Document';
import { SecurityScheme } from '../../core/models/common/SecurityScheme';
import { ChangeSecuritySchemeCommand } from './ChangeSecuritySchemeCommand';
import { AaiComponents } from '../../asyncapi/models/AaiComponents';
import { AaiSecurityScheme } from '../../asyncapi/models/AaiSecurityScheme';
import { AaiOAuthFlows } from '../../asyncapi/models/AaiOAuthFlows';

/**
 * A command used to change a security scheme in an aaidocument.
 * @author c.desc2@gmail.com
 * @extends ChangeSecuritySchemeCommand
 * @class
 */
export class ChangeSecuritySchemeCommand_Aai20 extends ChangeSecuritySchemeCommand {
    public constructor(scheme? : any) {
        if(((scheme != null && scheme instanceof <any>SecurityScheme) || scheme === null)) {
            let __args = arguments;
            super(scheme);
        } else if(scheme === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }

    /**
     * @see ChangeSecuritySchemeCommand#getSchemeFromDocument(Document)
     * @param {Document} document
     * @return {SecurityScheme}
     */
    getSchemeFromDocument(document : Document) : SecurityScheme {
        let aai20Document : Aai20Document = <Aai20Document>document;
        if(this.isNullOrUndefined(aai20Document.components)) {
            return null;
        }
        return aai20Document.components.getSecurityScheme(this._schemeName);
    }

    /**
     * @see ChangeSecuritySchemeCommand#nullScheme(SecurityScheme)
     * @param {SecurityScheme} scheme
     */
    nullScheme(scheme : SecurityScheme) {
        super.nullScheme(scheme);
        let aai20SecurityScheme : Aai20SecurityScheme = <Aai20SecurityScheme>scheme;
        aai20SecurityScheme.$ref = null;
        aai20SecurityScheme.scheme = null;
        aai20SecurityScheme.bearerFormat = null;
        aai20SecurityScheme.flows = null;
        aai20SecurityScheme.openIdConnectUrl = null;
    }
}
ChangeSecuritySchemeCommand_Aai20["__class"] = "io.apicurio.datamodels.cmd.commands.ChangeSecuritySchemeCommand_Aai20";
ChangeSecuritySchemeCommand_Aai20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




